import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AliasResolverService {
  private router = inject(Router);

  // Domínios base oficiais; qualquer label antes deles é considerado alias do cliente.
  private readonly BASE_HOSTS = ['dev.portal-beneficiario.totvs.io', 'portal-beneficiario.totvs.io'];

  resolveAlias(fromPath: string): { alias: string; usedSubdomain: boolean } {
    const normalizedPath = (fromPath || '').trim().toLowerCase();

    if (this.isLocal()) {
      return { alias: normalizedPath, usedSubdomain: false };
    }

    const prefixFromSubdomain = this.extractAliasFromSubdomain();
    const alias = prefixFromSubdomain
      ? [prefixFromSubdomain, normalizedPath].filter(Boolean).join(' ')
      : normalizedPath;

    return { alias: alias.trim(), usedSubdomain: !!prefixFromSubdomain };
  }

  extractAliasFromSubdomain(): string {
    if (this.isLocal()) {
      return '';
    }

    const rootHost = this.getRootHost();

    if (!rootHost || this.host === rootHost) {
      return '';
    }

    const aliasSection = this.host.slice(0, -(rootHost.length + 1));
    const [alias] = aliasSection.split('.');

    return alias || '';
  }

  navigateToLoginWithAlias(aliasInput: string): void {
    // alias sempre validado pelo Mingle antes de chegar aqui: "prefixo" ou "prefixo sufixo"
    const [prefix, suffix] = aliasInput.trim().toLowerCase().split(/\s+/, 2);

    if (this.isLocal()) {
      this.router.navigate(['login', aliasInput]);
      return;
    }

    // novo padrão: prefixo vai para o subdomínio e sufixo (quando existir) vai no path
    // Sempre monta a URL com domínio base para evitar alias em cascata (ex.: beta.alpha.dev...).
    const targetHost = `${prefix}.${this.getRootHost() || this.host}`;
    const loginPath = suffix ? `/login/${suffix}` : '/login';
    const targetUrl = `${window.location.protocol}//${targetHost}${loginPath}`;

    window.location.assign(targetUrl);
  }

  private getRootHost(): string {
    return this.BASE_HOSTS.find((baseHost) => this.host === baseHost || this.host.endsWith(`.${baseHost}`)) || '';
  }

  private isLocal(): boolean {
    return this.host === 'localhost' || this.host.endsWith('.localhost');
  }

  private get host(): string {
    return window.location.hostname.toLowerCase();
  }
}
